import React, {useEffect, useState} from "react";
import WidePanel from "../../components/section/wide-panel";
import Footer from "../../components/section/footer";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {getFormData, setFormData} from "../../components/manager/form";
import "../../style/custom/plan.scss";
import {getProductsQuery, getProductsResult} from "../../components/logic/products";
import {useQuery} from "@apollo/client";
import StandardTerms from "../../components/standard-terms";
import PrivacyPolicy from "../../components/portal/privacy-policy";

export default function Plan() {
  const data = getFormData();
  const [voucherCode, setVoucherCode] = useState(data.voucherCode);
  const [selectedProduct, setSelectedProduct] = useState(data.selectedProduct);
  const {building, locationId, addons = [], address} = data;
  const [date, setDate] = useState();
  const [showTerm, setTerm] = useState(false);
  const [showPolicy, setPolicy] = useState(false);

  const result = useQuery(getProductsQuery, {
    variables: {
      buildingCode: building?.code,
      voucherCode: voucherCode,
      showHidden: true,
    },
  });
  useEffect(() => {
    setFormData({voucherCode});
  }, [voucherCode]);

  useEffect(() => {
    setFormData({selectedProduct});
  }, [selectedProduct]);

  function handleOnSubmit({voucherCode}) {
    setVoucherCode(voucherCode);
  }
  if (result.loading) {
    return (<React.Fragment/>);
  }

  const products = getProductsResult(result);

  function setProduct(product) {
    const selectevents = product?.selectEventsActivate || [];
    let addons = [];

    (selectevents || []).forEach((event) => {
      const eventProduct = products.find((p) => (p.name || "").toLowerCase() === (event || "").toLowerCase());
      if (eventProduct) {
        addons.push(eventProduct);
      }
    });

    setFormData({addons});
    // let accessCircuitRef = data.locationId;
    // if (data.locationId.startsWith("VLC")) {
    //   accessCircuitRef = address.accessCircuitIds[0];
    // }
    // if (!accessCircuitRef.startsWith("VAC")) {
    //   throw new Error("Invalid access circuit ref");
    // }
    setSelectedProduct({
      ...product,
      // orderItemOpts: {
      //   accessCircuitRef,
      // },
    });
    // history.push("/review");
  }

  const handleConfirmPlanOrder = () => {
    window.location.href = "/register/user";
  };

  const handleOnAddProduct = (product, selectEvents) => {
    let newAddons = [...addons, product, ...selectEvents];
    newAddons = newAddons.filter((value, index) => newAddons.findIndex((na) => na.id === value.id) === index);

    const hardware = newAddons.filter((p) => p.type === "hardware").length > 0;
    setFormData({addons: newAddons, hardware});
    setDate(new Date()); //force page rerender
  };

  const handleOnRemoveProduct = (product, selectEvents) => {
    const newAddons = addons.filter((a) => a.id !== product.id);
    const hardware = newAddons.filter((p) => p.type === "hardware").length > 0;
    setFormData({addons: newAddons, hardware});
    setDate(new Date()); //force page rerender
  };



  // const {formatMessage} = props.intl;
  return (
    <>
      {showTerm && <StandardTerms onClose={() => setTerm(false)} />}
      {showPolicy && <PrivacyPolicy onClose={() => setPolicy(false)} />}
      <div className="plan-page-container">
        <div className="plan-page-inner">
          <div className="section-1">
            <Row className="vw-fs">
              <Col lg={12} className="vw-fs-section">
                <WidePanel
                  handleOnSubmit={handleOnSubmit}
                  voucherCode={voucherCode}
                  setVoucherCode={setVoucherCode}
                  onRemoveProduct={handleOnRemoveProduct}
                  onAddProduct={handleOnAddProduct}
                  products={products}
                  setProduct={setProduct}
                  selectedProduct={selectedProduct}
                  getPlanImage={getPlanImage}
                  getPlanSpeedLabel={getPlanSpeedLabel}
                  handleConfirmPlanOrder={handleConfirmPlanOrder}
                  addons={addons}
                />
              </Col>
            </Row>
          </div>
          <Footer setTerm={setTerm} setPolicy={setPolicy}/>
        </div>
      </div>
    </>
  );
}



export function getPlanSpeedLabelPlan(product) {
  switch (product) {
    case "50/20 Mbps":
      return "50/20";
    case "100/20 Mbps":
      return "100/20";
    case "250/25 Mbps":
      return "250/25";
    case "1000/50 Mbps":
      return "1000/50";
  }
  return "50/20";
}

export function getPlanSpeedLabel(product) {
  switch (product) {
    case "50/20 Mbps":
      return "47.3";
    case "100/20 Mbps":
    case "100/40 Mbps":
      return "96.4";
    case "250/25 Mbps":
    case "250/100 Mbps":
      return "241.0";
    case "1000/50 Mbps":
    case "1000/400 Mbps":
      return "250+";
  }
  return "47.3";
}

export function getPlanImage(product) {
  switch (product) {
    case "50/20 Mbps":
      return (<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 18 18"><path fill="#0065a0" fillOpacity=".3" d="M9.01 15.99l8.8-10.96C17.47 4.77 14.08 2 9 2S.53 4.77.19 5.03l8.8 10.96h.02z"/></svg>);
    case "100/20 Mbps":
    case "100/40 Mbps":
      return (<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 18 18"><path fill="#0065a0" fillOpacity=".3" d="M9.01 15.99l8.8-10.96C17.47 4.77 14.08 2 9 2S.53 4.77.19 5.03l8.8 10.96h.02z"/><path fill="#0065a0" d="M5.24 11.31L9 16l3.76-4.68C12.57 11.17 11.14 10 9 10c-2.14 0-3.57 1.17-3.76 1.31z"/></svg>);
    case "250/100 Mbps":
    case "250/25 Mbps":
      return (<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 18 18"><path fill="#0065a0" fillOpacity=".3" d="M9.01 15.99l8.8-10.96C17.47 4.77 14.08 2 9 2S.53 4.77.19 5.03l8.8 10.96h.02z"/><path fill="#0065a0" d="M3.98 9.75l5.01 6.24L9 16v-.01l5.01-6.24C13.76 9.56 11.85 8 9 8 6.15 8 4.24 9.56 3.98 9.75z"/></svg>);
    case "1000/400 Mbps":
    case "1000/50 Mbps":
      return (<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 18 18"><path fill="#0065a0" fillOpacity=".3" d="M9.01 15.99l8.8-10.96C17.47 4.77 14.08 2 9 2S.53 4.77.19 5.03l8.8 10.96h.02z"/><path fill="#0065a0" d="M2.73 8.19L9 15.99V16l.01-.01 6.27-7.8C14.96 7.94 12.56 6 9 6S3.04 7.94 2.73 8.19z"/></svg>);
    default:
      return (<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 18 18"><path fill="#0065a0" fillOpacity=".3" d="M9.01 15.99l8.8-10.96C17.47 4.77 14.08 2 9 2S.53 4.77.19 5.03l8.8 10.96h.02z"/></svg>);
  }
}

export function extractRateProfile(rateProfile) {
  const matches = /^(\d*)M\/(\d*)M|^(\d*)/g.exec(rateProfile);
  const down = matches[1] || matches[3];
  const up = matches[2];
  return {
    up,
    down,
  };
}

